/**
 * @description 正则常量
 * @created 2024/04/19 15:47:03
 */

// 数字
export const REGEX_NUMBER = /^\d+(\.\d+)?$/

// index.vue 文件后缀
export const REGEX_INDEX_VUE = /(\.\/|\/index.vue)/g
